// extracted by mini-css-extract-plugin
export var caption = "three-img-grid-module--caption--569aa";
export var credit = "three-img-grid-module--credit--3ab77";
export var image = "three-img-grid-module--image--c9ff6";
export var image_2row = "three-img-grid-module--image_2row--9bdcd";
export var img = "three-img-grid-module--img--d4fd5";
export var three = "three-img-grid-module--three--484eb";
export var three_images = "three-img-grid-module--three_images--2e6c3";